module.exports = "/assets/data/468fccc52c06413875ba5b324470dac8-KT10.data.json";